export default __webpack_public_path__ + "static/secondary-level-hero-image-c6ab0622e629c884a2ab4a93098f3489.jpg";